import axios from 'axios'
import {GENERAL_TYPES} from '../constants/general.types'
import {KEYS} from '../constants/keysStorage'
import * as http from '../api/http'
import {ENDPOINTS} from '../api/config'
import {Dispatch} from 'react'
import { determinarAMoPM, obtenerHoraActualStr } from '../utils/strings.utils'
import { State } from '../reducers'

export const generalSetHora = (datos: any) => ({
  type: GENERAL_TYPES.GENERAL_SET_HORA,
  payload: datos,
})

export const generalOpenModalError = (message: string, tipo: number | string = 500) => ({
  type: GENERAL_TYPES.OPEN_MODAL_ERROR,
  payload: {open: true, message, tipo},
})

export const generalCloseModalError = () => ({type: GENERAL_TYPES.CLOSE_MODAL_ERROR})

export const generalShowLoader = (flag: boolean) => ({
  type: GENERAL_TYPES.SHOW_LOADER,
  payload: flag,
})

export const generalOpenModalInfo = (message: string) => ({
  type: GENERAL_TYPES.OPEN_MODAL_INFO,
  payload: {open: true, message},
})

export const generalCloseModalInfo = () => ({type: GENERAL_TYPES.CLOSE_MODAL_INFO})

export const generalOpenModalMessage = (title: string, message: string) => ({
  type: GENERAL_TYPES.OPEN_MODAL_MESSAGE,
  payload: {open: true, title, message},
})

export const generalCloseModalMessage = () => ({type: GENERAL_TYPES.CLOSE_MODAL_MESSAGE})

export const generalOpenModalSuscripcion = () => ({type: GENERAL_TYPES.OPEN_MODAL_SUSCRIPCION})

export const generalCloseModalSuscripcion = () => ({type: GENERAL_TYPES.CLOSE_MODAL_SUSCRIPCION})

export const generalModalConfirmEdit = (active: any) => ({type: GENERAL_TYPES.GENERAL_ACTIVE_MODA_EDIT, payload: active})

export const generalOpenToastSuccess = (message: string, title: string = 'Mensaje') => ({
  type: GENERAL_TYPES.OPEN_TOAST,
  payload: {
    open: true,
    title,
    message,
    tipo: 1,
  },
})

export const generalOpenConfirmEdit = (onConfirmEdit: any, message?: string, title?: string) => ({
  type: GENERAL_TYPES.GENERAL_ACTIVE_MODA_EDIT,
  payload: {
    onConfirmEdit: onConfirmEdit,
    open: true,
    title: title || '',
    message: message || '',
  }
})

export const generalOpenToastError = (message: string, title: string = 'Error') => ({
  type: GENERAL_TYPES.OPEN_TOAST,
  payload: {
    open: true,
    title,
    message,
    tipo: 0,
  },
})

export const generalOpenToastInfo = (message: string, title: string = 'Aviso') => ({
  type: GENERAL_TYPES.OPEN_TOAST,
  payload: {
    open: true,
    title,
    message,
    tipo: 2,
  },
})

export const generalOpenToastWarning = (message: string, title: string = 'Advertencia') => ({
  type: GENERAL_TYPES.OPEN_TOAST,
  payload: {
    open: true,
    title,
    message,
    tipo: 3,
  },
})

export const generalCloseToast = () => ({type: GENERAL_TYPES.CLOSE_TOAST})

export const generalOpenModalLimite = (message: string, limite: number, color: string = "black", title: string = 'Alerta') => ({
  type: GENERAL_TYPES.OPEN_MODAL_LIMITE,
  payload: {
    open: true,
    title,
    message,
    color,
    limite
  },
})

export const generalCloseModalLimite = () => ({type: GENERAL_TYPES.CLOSE_MODAL_LIMITE})

export const cerrarSesion = () => {
  const keys: any = KEYS
  const ExceptionKeys = ['MESSAGE_SESSION_ERROR'];

  axios.defaults.headers.common = {Authorization: ''}
  for (const key in keys) {
    if (!ExceptionKeys.includes(key))
      localStorage.removeItem(keys[key])
  }
}

export const getFechaHora = () => async (dispatch: Dispatch<any>) => {
  try {
    const res:any = await http.get(ENDPOINTS.GET_FECHA);
    if (res?.body) {
      const datosActuales = res?.body;
      const partes = datosActuales.Fecha.split('-');
      // Reorganizamos las partes para multiples formatos
      const formatos = {
        FechaInput: `${partes[2]}-${partes[1]}-${partes[0]}`, 
        FechaDDMM: `${partes[1]}/${partes[0]}/${partes[2]}`,
        Hora: datosActuales.Hora, 
      }
      dispatch(generalSetHora(formatos));
      return formatos;
    }
    return false;
  } catch (err) {
    return false;
  }
}

export const validateHorarioSucursal = (hora:string = "", returnUrl = "/home", showLoader = false, action = 'emitir el documento') => async (dispatch: Dispatch<any>, getState: () => State) => {
  try {
    const {datos} = getState().userLogin;
    if (showLoader) dispatch(generalShowLoader(true));

    const res:any = await http.get(ENDPOINTS.GET_FECHA);
    const horaActual = res?.body?.Hora ?? hora;
    const hhMM = obtenerHoraActualStr(horaActual);

    if (!datos.sucursal_hora_inicio && !datos.sucursal_hora_final) {
      dispatch(generalShowLoader(false));
      return true;
    } 

    const hora_inicio = new Date(`1970-01-01T${datos.sucursal_hora_inicio}:00`);
    const hora_final = new Date(`1970-01-01T${datos.sucursal_hora_final}:00`);
    const hora_actual_obj = new Date(`1970-01-01T${hhMM}:00`);

    dispatch(generalShowLoader(false));
    // Comprueba si la hora actual está dentro del rango
    if (!(hora_actual_obj >= hora_inicio && hora_actual_obj <= hora_final)) {
      const nota = `<br/><br/><p style="color: #019FC5">Nota: En caso de que sea necesario corregir o actualizar este horario, por favor contacta a tu supervisor.</p>`;
      dispatch(generalOpenModalInfo(`No es posible ${action}, la sucursal se encuentra fuera de horario de atención <b>(${datos.sucursal_hora_inicio}${determinarAMoPM(datos.sucursal_hora_inicio)}-${datos.sucursal_hora_final}${determinarAMoPM(datos.sucursal_hora_final)})</b>.${datos?.role !== "2" ? nota : ''}`));
      dispatch(generalSetValidReturn(returnUrl));
      return false;
    }
    return true;
  } catch (err) {}
}

export const generalSetValidReturn = (url: string) => ({type: GENERAL_TYPES.GENERAL_SET_RETURN_VALID, payload: url})

export const validateUsoModulo = (returnUrl = "/home") => async (dispatch: Dispatch<any>, getState: () => State) => {
  try {
    dispatch(generalShowLoader(true)); 
    const {datos} = getState().userLogin;

    // Validacion ASPEL -> true, no es posible utilizar modulos de facturacion
    if (datos.aspel) {
      dispatch(generalOpenModalInfo(msgFuncionalidadLimitada(datos)));
      dispatch(generalSetValidReturn(returnUrl)); 
    }
  } catch (err) {}
  finally { 
    dispatch(generalShowLoader(false)); 
  }
}

export const msgFuncionalidadLimitada = (datosUser: any) => {
  return `Funcionalidad limitada. ${datosUser?.role !== "2" ? 'Por favor, contacta a tu supervisor para obtener más detalles.' : 'Por favor, contacta a FELES para obtener más detalles.'}`;
}
